import api from './api';

/**
 * Post a new issue.
 * @param {Issue} issue
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export const postIssue = async (issue) => api.post('/issue', issue);
